<template>
  <div class="box13-page">
    <pageTitle :title="'常见问题'" :tit="''" />
    <commonProblem
      :problemData="problemData"
      :titleLeftHover="titleLeftHover"
      :styleData="styleData"
      :pageName="pageName"
    />
  </div>
</template>

<script>
import pageTitle from "../../../components/common/pageTitle.vue";
import commonProblem from "../../../components/common/common-problem.vue";
export default {
  components: {
    pageTitle,
    commonProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "想做抖音，不知道拍什么好？",
          answer:
            "报名课程之后会有专业运营老师一对一指导咱们去做账号定位，做内容分类。",
        },
        {
          title: "拍了几个作品，一直不涨粉怎么办？",
          answer:
            "这个问题需要专业老师针对性的分析一下咱们的账号问题，然后根据具体问题去进行内容调整优化。",
        },
        {
          title: "可以先试学一下么？",
          answer:
            "咱们第一章节开通了试学课程，可以先试学，满意再报名~",
        },
      ],

      titleLeftHover: "#3e82f7",

      pageName: "newMedia2专题页",

      styleData: {
        iconQuestion: require("@/assets/topic-page/newMedia2/box13/icon-Q.png"),
        iconDown: require("@/assets/topic-page/java/problem/icon-down.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("newMedia2-就业课","了解更多",0,null)
      
      qimoChatClick();
    },
  },
};
</script>

<style lang="scss" scoped>
.box13-page {
  margin: 0 auto;
  padding: 80px 0px;
  max-width: 2048px;
  min-width: 1400px;
  background: url("../../../assets/topic-page/newMedia2/box13/bg.jpg") no-repeat;
  background-size: 2100px auto;
  .content {
    margin: 0 auto;
    margin-top: 60px;
    padding: 32px 60px;
    width: 1200px;
    background: #fff;
    box-shadow: 0px 6px 18px 0px rgba(94, 123, 218, 0.08),
      0px 3px 6px -4px rgba(94, 123, 218, 0.12);
    border-radius: 12px;
    box-sizing: border-box;
  }

  .question-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 72px;
    cursor: pointer;
    .title-left {
      display: flex;
      align-items: center;
      .question-icon {
        margin-right: 16px;
        width: 24px;
        height: 24px;
      }

      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
    }
    .title-right {
      width: 24px;
      height: 24px;

      img {
        width: 100%;
        height: 100%;
        transition: 0.5s ease all;
      }
      .img-rotate {
        transition: 0.5s ease all;
        transform: rotate(180deg);
      }
    }

    &:hover {
      .title-left {
        color: #3e82f7;
      }
    }
  }

  .question-answer {
    margin: 0 auto;
    padding: 6px 0px 16px 0px;
    width: 1000px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    transition: 0.5s ease all;
  }

}
</style>